export const SET_PDF_TITLE = "SET_PDF_TITLE";
export const SET_PDF_COVER = "SET_PDF_COVER";
export const SET_PDF_URL = "SET_PDF_URL";
export const RESET_PDF = "RESET_PDF";
export const SET_PDF_DATE = "SET_PDF_DATE";
export const ADD_PDFS = "ADD_PDFS";
